import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1581.29412,1694.11765 C1581.29412,1756.34824 1530.69647,1807.05882 1468.35294,1807.05882 L451.882353,1807.05882 C389.651765,1807.05882 338.941176,1756.34824 338.941176,1694.11765 L338.941176,1016.47059 L451.882353,1016.47059 L1468.35294,1016.47059 L1581.29412,1016.47059 L1581.29412,1694.11765 Z M1468.35294,903.529412 L1468.35294,508.235294 C1468.35294,228.028235 1240.32471,0 960.117647,0 C679.910588,0 451.882353,228.028235 451.882353,508.235294 L451.882353,903.529412 L226,903.529412 L226,1694.11765 C226,1818.69176 327.308235,1920 451.882353,1920 L1468.35294,1920 C1592.92706,1920 1694.23529,1818.69176 1694.23529,1694.11765 L1694.23529,903.529412 L1468.35294,903.529412 Z M1016.58824,1242.35294 L1016.58824,1581.17647 L903.647059,1581.17647 L903.647059,1242.35294 L1016.58824,1242.35294 Z M960.117647,112.941176 C1178.09412,112.941176 1355.41176,290.258824 1355.41176,508.235294 L1355.41176,903.529412 L564.823529,903.529412 L564.823529,508.235294 C564.823529,290.258824 742.141176,112.941176 960.117647,112.941176 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconLockLine = /*#__PURE__*/function (_Component) {
  _inherits(IconLockLine, _Component);

  var _super = _createSuper(IconLockLine);

  function IconLockLine() {
    _classCallCheck(this, IconLockLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconLockLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconLock",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconLockLine.displayName = "IconLockLine";
  return IconLockLine;
}(Component);

IconLockLine.glyphName = 'lock';
IconLockLine.variant = 'Line';
IconLockLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconLockLine;
export { IconLockLine };